import { apiClient } from "../config";

async function getObservations(queryParams: any) {
  const res = await apiClient.get(`/admin/dashboard/widget/observations`, {
    params: queryParams,
  });
  return res.data;
}

export default getObservations;
